<template>
	<div v-if="showItemHeader || !isEmpty(filteredItems)">
		<SubMenuTitle :iconName="nodeServiceSlug" :title="nodeTitle" />
		<DataInputMenuItems
			v-on="$listeners"
			ref="data_input_items"
			:item="step"
			:stepIndex="index"
			:isTableOnly="isTableOnly"
			:searchString="searchString"
			:filteredItems="filteredItems"
			:useWithFormulas="useWithFormulas"
			:dataInputParam="dataInputParam"
			:contentRectYAxis="contentRectYAxis"
			:focusedMenuItemKey="focusedMenuItemKey"
			:allowTableSelection="allowTableSelection"
			:didFocusFromBottomToTop="didFocusFromBottomToTop"
			:preventTables="preventTables"
			@mark-search-string="markSearchString"
			@highlight-menu-message="highlightMenuMessage"
		/>
	</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

import { TEST_RESULT_STATUSES } from '@/utils/workflow-node.const';
import SubMenuTitle from '@/components/DataInput/DataInputMenu/SubMenuTitle';
import { markString } from '@/components/DataInput/DataInputMenu/helpers/helpers';
import DataInputMenuItems from '@/components/DataInput/DataInputMenu/MenuLists/helpers/DataInputMenuItems';
import { SET_VALUE_FROM_EXTERNAL_SOURCE } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';

export default {
	name: 'StepExpandedData',
	components: {
		SubMenuTitle,
		DataInputMenuItems,
	},
	props: {
		step: { type: Object },
		index: { type: Number },
		searchString: { type: String },
		filteredItems: { type: Object },
		contentRectYAxis: { type: Number },
		dataInputParam: { type: Object },
		focusedMenuItemKey: { type: String },
		useWithFormulas: { type: Boolean },
		showItemHeader: { type: Boolean },
		allowTableSelection: { type: Boolean },
		isTableOnly: { type: Boolean },
		didFocusFromBottomToTop: { type: Boolean },
		preventTables: { type: Boolean },
	},
	computed: {
		nodeInfo() {
			return this.step?.nodeInfo;
		},
		nodeServiceSlug() {
			return this.nodeInfo?.serviceSlug;
		},
		nodeTitle() {
			return this.nodeInfo?.nodeTitle;
		},
	},
	methods: {
		triggerChildFunc(funcName) {
			this.$nextTick(() => {
				this.$refs.data_input_items && this.$refs.data_input_items[funcName] && this.$refs.data_input_items[funcName]();
			});
		},
		selectFocusedItem() {
			// Called from Parent
			this.triggerChildFunc('selectFocusedItem');
		},
		focusOnNextMenuItem() {
			// Called from Parent
			this.triggerChildFunc('focusOnNextMenuItem');
		},
		focusOnPreviousMenuItem() {
			// Called from Parent
			this.triggerChildFunc('focusOnPreviousMenuItem');
		},
		selectTableColumn() {
			// called from parent
			this.triggerChildFunc('selectTableColumn');
		},
		onItemClicked(...args) {
			this.$emit('set-data-input-menu-item', ...args);
		},
		itemClick(item) {
			if (!this.allowMultipleSelection) {
				this.$emit(SET_VALUE_FROM_EXTERNAL_SOURCE, item);
			}
		},
		markSearchString(str) {
			return markString(this.searchString, str);
		},
		showItem(item) {
			return [TEST_RESULT_STATUSES.SKIPPED, TEST_RESULT_STATUSES.SUCCESS].includes(item.nodeInfo.testResultStatus) && !isEmpty(item.items);
		},
		highlightMenuMessage() {
			this.$emit('highlight-menu-message');
		},
		isEmpty(value) {
			return isEmpty(value);
		},
	},
};
</script>

<style scoped lang="scss"></style>
